import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { ProductPropertiesModel } from "@rightstore/Model/ProductProperties.model";
import useProductProperties from "@rightstore/Model/useProductProperties";
import * as React from "react";

export interface HasProductProperties {
    productContext: ProductContextModel;
    productProperties: ProductPropertiesModel;
}

export function withProductProperties<P extends HasProductProperties>(Component: React.ComponentType<P>) {
    return function ProductComponent(props: Omit<P, keyof HasProductProperties>) {
        return (
            <ProductContext.Consumer>
                {value => <Component 
                    {...(props as P)} 
                    productContext={value} 
                    productProperties={useProductProperties(value.product)} />}
            </ProductContext.Consumer>
        );
    };
}
